import React, { useRef } from 'react';
import { Draggable } from 'react-draggable';
import '../styles/nodes.css';

const Node = ({
  id,
  type,
  x,
  y,
  width,
  height,
  content,
  color,
  isSelected,
  onSelect,
  onDragStart,
  onDrag,
  zoom
}) => {
  const nodeRef = useRef(null);

  const handleClick = (e) => {
    e.stopPropagation();
    onSelect(id, e.shiftKey);
  };

  const handleDrag = (e, data) => {
    onDrag(id, {
      x: data.x / zoom,
      y: data.y / zoom
    });
  };

  const renderNodeContent = () => {
    switch (type) {
      case 'rectangle':
        return (
          <div
            className={`node rectangle ${isSelected ? 'selected' : ''}`}
            style={{
              backgroundColor: color,
              width: `${width}px`,
              height: `${height}px`
            }}
          />
        );
      case 'circle':
        return (
          <div
            className={`node circle ${isSelected ? 'selected' : ''}`}
            style={{
              backgroundColor: color,
              width: `${width}px`,
              height: `${height}px`,
              borderRadius: '50%'
            }}
          />
        );
      case 'text':
        return (
          <div
            className={`node text ${isSelected ? 'selected' : ''}`}
            style={{
              color: '#000',
              backgroundColor: color,
              width: `${width}px`,
              height: `${height}px`,
              padding: '8px'
            }}
          >
            {content}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Draggable
      position={{ x: x * zoom, y: y * zoom }}
      onStart={() => onDragStart(id)}
      onDrag={handleDrag}
      nodeRef={nodeRef}
    >
      <div
        ref={nodeRef}
        className="node-container"
        onClick={handleClick}
        style={{ position: 'absolute' }}
      >
        {renderNodeContent()}
      </div>
    </Draggable>
  );
};

export default Node;